import React from 'react';
import HBText from '@honeybook/hbui/dist/components/HBText/HBText';
import Email24 from '@honeybook/icons/dist/icons/Email24';
import { observer } from 'mobx-react';
import colors from '@honeybook/hbui/dist/styles/colors';
import styled from 'styled-components';
import Clip16 from '@honeybook/icons/dist/icons/Clip16';
import Connected16 from '@honeybook/icons/dist/icons/Connected16';
import {
    flexCenterAll,
    truncatedText
} from '@honeybook/hbui/dist/styles/mixins';
import HBTooltip from '@honeybook/hbui/dist/components/HBTooltip/HBTooltip';
import {
    ActionTypeText,
    AutomationBlockContent
} from '../AutomationsBuilder.styles';
import { TAutomationBlockAction } from '~/types/automation.types';

const AutomationBlockActionEmail: TAutomationBlockAction = ({
    step,
    color
}) => {
    return (
        <AutomationBlockContent>
            <Email24 color={color} />
            <ActionTypeText type="Title3DarkPrimary">Send Email</ActionTypeText>
            <Template>
                <Title
                    align="center"
                    type={
                        step.email ? 'Body6DarkPrimary' : 'Body6DarkSecondary'
                    }
                >
                    {step.title || 'Choose template on the right'}
                </Title>
                {!!step.email && !step.genericEmail && (
                    <HBTooltip
                        targetContainerStyle={{ display: 'flex' }}
                        placement="top"
                        target={
                            <ConnectedIcon
                                color={colors.neutral600}
                                hoverColor={colors.neutral800}
                            />
                        }
                    >
                        Email connected to template
                    </HBTooltip>
                )}
                {!!step.attachmentsCount && (
                    <>
                        <ClipIcon color={colors.neutral600} />
                        <HBText type="Body6DarkSecondary">
                            {step.attachmentsCount}
                        </HBText>
                    </>
                )}
            </Template>
        </AutomationBlockContent>
    );
};

export default observer(AutomationBlockActionEmail);

const Template = styled.div`
    align-self: stretch;
    ${flexCenterAll}
`;

const ClipIcon = styled(Clip16)`
    display: flex;
    margin: 0 2px 0 4px;
`;

const ConnectedIcon = styled(Connected16)`
    display: flex;
    margin-left: 4px;
`;

const Title = styled(HBText)`
    ${truncatedText}
`;
